// C'est le Routeur de l'application .

import React from "react";
import { Routes, Route, Navigate, Outlet } from "react-router-dom";
import Users from "./components/Users/Users";
import Login from "./components/Login/Login";
import AddUser from "./components/AddUser/AddUser";
import ViewUser from "./components/ViewUser/ViewUser";
import EditUser from "./components/EditUser/EditUser";
import ViewUserTabs from "./components/ViewUserTabs/ViewUserTabs";
import EditUserTabs from "./components/EditUserTabs/EditUserTabs";
import Tabs from "./components/Tabs/Tabs";
import AddTab from "./components/AddTab/AddTab";
import EditTab from "./components/EditTab/EditTab";

// Propriétés attendues pour le composant RoutesComponent
interface RoutesComponentProps {
  isAuthenticated: boolean;
}

const RoutesComponent: React.FC<RoutesComponentProps> = ({
  isAuthenticated,
}) => {
  // Layout pour la section Users
  const UsersLayout = () => <Outlet />;

  // Layout pour la section Tabs
  const TabsLayout = () => <Outlet />;

  return (
    <Routes>
      {!isAuthenticated ? ( // Si l'utilisateur n'est pas authentifié
        <>
          <Route path="/login" element={<Login />} />{" "}
          {/* Affiche le formulaire de login */}
          <Route path="*" element={<Navigate to="/login" />} />{" "}
          {/* Redirige vers /login pour toutes les autres routes */}
        </>
      ) : (
        // Si l'utilisateur est authentifié
        <>
          {/* Section Users */}
          <Route path="/users" element={<UsersLayout />}>
            {" "}
            {/* Utilise UsersLayout comme layout pour toutes les routes sous /users */}
            <Route path="" element={<Users />} />{" "}
            {/* Affiche la liste des utilisateurs par défaut */}
            <Route path="all" element={<Users />} />{" "}
            {/* Affiche la liste des utilisateurs pour /users/all */}
            <Route path="add" element={<AddUser />} />{" "}
            {/* Affiche le formulaire d'ajout d'utilisateur */}
            <Route path=":id/view" element={<ViewUser />} />{" "}
            {/* Affiche les détails d'un utilisateur */}
            <Route path=":id/edit" element={<EditUser />} />{" "}
            {/* Affiche le formulaire d'édition d'utilisateur */}
            <Route path=":id/tabs" element={<TabsLayout />}>
              {" "}
              {/* Utilise TabsLayout comme layout pour toutes les routes sous /users/:id/tabs */}
              <Route path="view" element={<ViewUserTabs />} />{" "}
              {/* Affiche les onglets d'un utilisateur */}
              <Route path="edit" element={<EditUserTabs />} />{" "}
              {/* Affiche le formulaire d'édition des onglets d'un utilisateur */}
              <Route path="*" element={<Navigate to="/users/all" />} />{" "}
              {/* Redirige vers /users/all pour toutes les autres routes sous /users/:id/tabs */}
            </Route>
          </Route>
          {/* Section Tabs */}
          <Route path="/tabs" element={<TabsLayout />}>
            {" "}
            {/* Utilise TabsLayout comme layout pour toutes les routes sous /tabs */}
            <Route path="" element={<Tabs />} />{" "}
            {/* Affiche la liste des onglets par défaut */}
            <Route path="all" element={<Tabs />} />{" "}
            {/* Affiche la liste des onglets pour /tabs/all */}
            <Route path="add" element={<AddTab />} />{" "}
            {/* Affiche le formulaire d'ajout d'onglet */}
            <Route path=":id/edit" element={<EditTab />} />{" "}
            {/* Affiche le formulaire d'édition d'onglet */}
          </Route>
          <Route path="/login" element={<Navigate to="/users/all" />} />{" "}
          {/* Redirige vers /users/all lors de l'accès à /login */}
          <Route path="*" element={<Navigate to="/users/all" />} />{" "}
          {/* Redirige vers /users/all pour toutes les autres routes */}
        </>
      )}
    </Routes>
  );
};

export default RoutesComponent;
